import LoginContainer from "../components/atomic/molecular/LoginContainer";
import VerificationCode from "../components/atomic/organisms/VerificationCode";

const ForgotPassConform = () => {
  const handleAfterConform = () => {
    alert("パスワードの変更が完了しました。ログインしてください");
  };

  return (
    <LoginContainer label={"パスワード変更後、確認コード入力"}>
      <VerificationCode
        handleAfterConform={handleAfterConform}
        isPassword={true}
      />
    </LoginContainer>
  );
};

export default ForgotPassConform;
